var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditSlippageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16495 13.1282H13",
    stroke: "#FD6D00",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52001 2.02986C8.0371 1.41186 8.96666 1.32124 9.59748 1.82782C9.63236 1.85531 10.753 2.72586 10.753 2.72586C11.446 3.14479 11.6613 4.0354 11.2329 4.71506C11.2102 4.75146 4.87463 12.6763 4.87463 12.6763C4.66385 12.9393 4.34389 13.0945 4.00194 13.0982L1.57569 13.1287L1.02902 10.8149C0.952442 10.4895 1.02902 10.1478 1.2398 9.8849L7.52001 2.02986Z",
    stroke: "#FD6D00",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34723 3.50098L9.98206 6.29239",
    stroke: "#FD6D00",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSlippageIcon);
export default __webpack_public_path__ + "static/media/edit-slippage-icon.737bae29eb0e66ed04e6af8a08760fcf.svg";
export { ForwardRef as ReactComponent };